
import React from 'react';
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowRightIcon, CheckCircle2, HelpCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BillingCycleSelector } from "@/components/dashboard/subscription/components/BillingCycleSelector";
import { SubscriptionPlanType } from "./utils";

// These are required returns to make TypeScript happy
function handlePlanSelectWithDowngrade(): null { return null; }
function handleToggleBillingCycle(): null { return null; }

export function PlanSelector({
  planConfigs,
  selectedPlan,
  onSelectPlan,
  // Add onPlanSelect as an alias for onSelectPlan to fix the build error
  onPlanSelect,
  hasActiveSubscription = false,
  currentPlan = "trial",
  confirmDialogOpen = false,
  isAnnual = false,
  setIsAnnual,
  showTrialMessage = false,
  onConfirmDowngrade,
  onCancelDowngrade,
  onManageSubscription,
  isLoading = false,
  isUpgrade = false,
  pendingDowngrade = false,
  nextPlan,
  downgradeDate,
  buttonText = "Select this plan",
  controlsText,
  subtitle,
  viewOnly = false,
}) {
  // Use onPlanSelect as a fallback for onSelectPlan if provided
  const handleSelectPlan = onSelectPlan || onPlanSelect;
  
  // This logging helps identify issues with the plan selector
  console.log("[PlanSelector] Props:", {
    planConfigs,
    selectedPlan,
    hasActiveSubscription,
    currentPlan,
    isAnnual,
    showTrialMessage,
    pendingDowngrade,
    nextPlan,
  });
  
  return (
    <Dialog open={confirmDialogOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Confirm Plan Change</DialogTitle>
          <DialogDescription>
            {pendingDowngrade ? (
              <>
                Are you sure you want to cancel the downgrade from <strong>{currentPlan}</strong> to <strong>{nextPlan}</strong>?
                This change is scheduled for <strong>{downgradeDate}</strong>.
              </>
            ) : isUpgrade ? (
              <>
                Are you sure you want to upgrade to the <strong>{selectedPlan}</strong> plan?
              </>
            ) : (
              <>
                Are you sure you want to downgrade from <strong>{currentPlan}</strong> to <strong>{selectedPlan}</strong>?
                This change will take effect at the end of your current billing cycle.
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="secondary" onClick={pendingDowngrade ? onCancelDowngrade : onManageSubscription}>
            {pendingDowngrade ? "Keep Downgrade" : "Cancel"}
          </Button>
          <Button type="button" onClick={pendingDowngrade ? onConfirmDowngrade : handleSelectPlan} disabled={isLoading}>
            {pendingDowngrade ? "Cancel Downgrade" : "Confirm"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
